import { createAsyncThunk } from '@reduxjs/toolkit';

import type { ThunkConfig } from 'app/providers/StoreProvider/config/types';

export interface MakeAllNotificationsReadResponse {
    notificationsRead: number;
    status: string;
}

export const makeNotificationsAsReadService = createAsyncThunk<
    MakeAllNotificationsReadResponse,
    string[],
    ThunkConfig<string>
>(
    'notifications/makeAllNotificationsAsReadService',
    async (notificationIds, thunkApi) => {
        const { extra, rejectWithValue } = thunkApi;

        try {
            const response =
                await extra.api.post<MakeAllNotificationsReadResponse>(
                    `/v1/users/notifications`,
                    { notificationIds },
                );

            return response.data;
        } catch (e) {
            return rejectWithValue('error');
        }
    },
);
